<script>
import { mapGetters } from 'vuex'
export default {
    name: 'PageBar',
    props: {
        top: {
            type: Number,
            default: 52
        },
        isTop: {
            type: Boolean,
            default: true
        },
        bottom: {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapGetters([
            'sidebar'
        ])
    },
    render(h) {
        // console.log(this.sidebar, 111);
        const nodes = [ ];
        if (this.$scopedSlots.default) {
            nodes.push(this.$scopedSlots.default())
        }
        return h('div', { 
            class: [ 'fixed-bar', this.isTop ? 'top' : 'bottom' ],
            style: {
                '--t': `${this.top}px`,
                '--b': `${this.bottom}px`,
                '--l': `${this.sidebar.opened? 240 : 80 }px`,
            }
        }, nodes);
    }
}
</script>

<style lang="scss" scoped>
.fixed-bar {
    position: fixed;
   
    z-index: 50;
    width: calc(100% - var(--l));
    transition: width 0.3s;
    &.top {
        top: var(--t);;
    }
    &.bottom {
        bottom: var(--b);
    }
}
</style>